export type PeriodDir = 'Last' | 'Next';
export type PeriodUnit = 'Years' | 'Months';